<template>
  <v-app class="gradien_gray">
    <v-card flat style="background-color: transparent;" v-if="jwt">
      <v-img class="hidden-sm-and-down" src="demo.paco-slider-recettegk-is-729.jpg" aspect-ratio="9"></v-img>

      <v-layout row pb-2>
        <v-flex md8 offset-md2>
          <v-card class="card--flex-toolbar" v-bind:class="$vuetify.breakpoint.name" flat
            style="background-color: transparent;">
            <!-- toolbar principale -->
            <v-toolbar card class="paco_gradient_2">
              <v-avatar size="40px">
                <v-img src="pacoclean_logo_gris.png"></v-img>
              </v-avatar>

              <img src="cocurachef.png" style="height:24px; margin-left:1rem;" v-if="breakpoint != 'xs'">
              <img src="cocurachef.png" style="height:20px; margin-left:1rem;" v-if="breakpoint == 'xs'">
              <!--
              <v-toolbar-title class="white--text">{{ $t("main.title") }}</v-toolbar-title>
              -->
              <v-spacer></v-spacer>

              <v-btn dark @click="dialog = true" icon v-if="breakpoint == 'xs' || breakpoint == 'sm'">
                <v-icon>settings</v-icon>
              </v-btn>

              <v-btn dark @click="dialog = true" flat v-else>
                <v-icon left>settings</v-icon>
                {{ $t("settings.title") }}
              </v-btn>

              <span v-if="userData && breakpoint != 'xs'" style="color: white">{{ userData.name }}</span>

              <v-btn dark @click="logout()" icon>
                <v-icon>logout</v-icon>
              </v-btn>

              <!--
              <v-btn dark @click="logout()" flat v-else>
                <v-icon left>logout</v-icon>Déconnexion
              </v-btn>
              -->
            </v-toolbar>

            <!-- toolbar secondaire (du four) -->
            <MainToolbar v-if="oven"></MainToolbar>
            <div v-else class="pl-3 pr-3 pt-2">
              Aucun four séléctionné.
              <br>Rendez-vous dans les réglages.
            </div>

            <!-- toolpartie recette (du four) -->
            <ProgBar v-if="oven && auto == '1'"></ProgBar>

            <v-content>
              <!-- Partir principale des commandes (si four sélectionné) -->
              <Main v-if="oven" />

              <!-- si pas de four sélectionné
              <v-card v-else>
                <v-card-title primary-title>
                  <div>
                    <h3 class="headline mb-0">{{ $t('main.noOven') }}</h3>
                    <div>{{ $t('main.noOvenMessage') }}</div>
                  </div>
                </v-card-title>
              </v-card>
              -->
            </v-content>
          </v-card>

          <!-- <Debug class="mt-3" v-if="oven"></Debug> -->

          <!--
          <v-footer height="auto" id="footer">
            <v-layout justify-center row wrap>
              <v-flex py-3 text-xs-center xs12>
                <a id="site" href="https://www.pacoclean.com" target="_blank">pacoclean.com</a>
              </v-flex>
            </v-layout>
          </v-footer>
          -->
        </v-flex>
      </v-layout>
    </v-card>

    <Login v-else></Login>

    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <Settings v-on:close="dialog = false" ref="settings"></Settings>
    </v-dialog>
  </v-app>
</template>

<script>
import Vue from "vue";
import jwtDecode from "jwt-decode";

import Main from "./components/Main";
import MainToolbar from "./components/MainToolbar";
// import Welcom from "./components/Welcom";
import Login from "./components/Login";
import ProgBar from "./components/ProgBar";
import Settings from "./components/Settings";
import Debug from "./components/Debug";
import config from "./config";

export default {
  name: "App",
  components: {
    Main,
    MainToolbar,
    Settings,
    Login,
    Debug,
    ProgBar
  },
  data() {
    return {
      dialog: false,
      toggle_mode: null,
      standby: false,
      icons: [
        "fab fa-facebook",
        "fab fa-twitter",
        "fab fa-google-plus",
        "fab fa-linkedin",
        "fab fa-instagram"
      ]
    };
  },
  computed: {
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
    oven() {
      return this.$store.state.oven;
    },
    ovenData() {
      return this.$store.state.ovenData;
    },
    auto() {
      return this.ovenData.auto;
    },
    location() {
      return window.location;
    },
    jwt() {
      return this.$store.state.jwt;
    },
    userData() {
      if (this.jwt) {
        return jwtDecode(this.jwt);
      }
    }
  },
  methods: {
    // ouvre la dialog d'ajout de four dans settings
    openAddOvenDialog() {
      this.$refs.settings.addOvenDialog = true;
    },
    // logout
    logout() {
      this.$store.dispatch("logout");
    }
  },
  watch: {
    // jwt
    jwt() {
      // charge en ligne la liste des fours
      this.$store.dispatch("loadOvenList");
      // lance la connexion si four associé
      this.$store.dispatch("initOvenOnline");
    }
  }
};
</script>

<style>
.gradien_gray {
  background-image: linear-gradient(to bottom, #b2b5b7, #eff0f0) !important;
}

.card--flex-toolbar.xl,
.card--flex-toolbar.lg {
  margin-top: -128px;
}

.card--flex-toolbar.md {
  margin-top: -64px;
}

#footer {
  background-color: transparent;
}

#site {
  text-decoration: none;
}

#site:hover {
  text-decoration: underline;
}

#ovenName {
  color: black;
}

/* cyrillic */
@font-face {
  font-family: "Exo 2";
  font-style: normal;
  font-weight: 400;
  src: local("Exo 2"), local("Exo2-Regular"),
    url(assets/fonts/7cHmv4okm5zmbtYsK-4E4Q.woff2) format("woff2");
  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}

/* latin-ext */
@font-face {
  font-family: "Exo 2";
  font-style: normal;
  font-weight: 400;
  src: local("Exo 2"), local("Exo2-Regular"),
    url(assets/fonts/7cHmv4okm5zmbtYmK-4E4Q.woff2) format("woff2");
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
    U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}

/* latin */
@font-face {
  font-family: "Exo 2";
  font-style: normal;
  font-weight: 400;
  src: local("Exo 2"), local("Exo2-Regular"),
    url(assets/fonts/7cHmv4okm5zmbtYoK-4.woff2) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
    U+FEFF, U+FFFD;
}

.paco_typo {
  font-family: "Exo 2" !important;
}

.paco_gradient {
  background-image: linear-gradient(to bottom, #000, #ba0a15, #000);
}

.paco_gradient_2 {
  background-image: linear-gradient(to bottom, #ba0a15, #58302d);
}

/* rond */
.rond {
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}

.vert {
  color: #cbff00;
}

.boutonRond {
  border-radius: 10px;
}

/* icomooon font */
@font-face {
  font-family: "icomoon";
  src: url("assets/icomoon-font/icomoon.eot?gqeqt1");
  src: url("assets/icomoon-font/icomoon.eot?gqeqt1#iefix") format("embedded-opentype"),
    url("assets/icomoon-font/icomoon.ttf?gqeqt1") format("truetype"),
    url("assets/icomoon-font/icomoon.woff?gqeqt1") format("woff"),
    url("assets/icomoon-font/icomoon.svg?gqeqt1#icomoon") format("svg");
  font-weight: normal;
  font-style: normal;
}

[class^="icon-"],
[class*=" icon-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icomoon" !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-cloud:before {
  content: "\e900";
}

.icon-ventil_2:before {
  content: "\e903";
}

.icon-ventil:before {
  content: "\e902";
}

.icon-oven:before {
  content: "\e901";
}
</style>
